import qs from 'qs';

import { client } from '@api/client';
import { URL } from '@api/urls';

import { TDefaultDTO } from '@interfaces/common/defaultDTO';
import { IBrandingSetup } from '@interfaces/platform/branding';
import {
	IBrandingSetupsDTO,
	ICreateBrandingSetupsDTO,
	IEditBrandingSetupsDTO,
} from '@interfaces/platform/dto/brandingDTO';

const {
	organizationsBranding,
	organizationsBrandingList,
	organizationsBrandingCreate,
} = URL;

export const getBrandingSetups = ({
	page,
	pageSize,
	sortDirection,
	sortFieldName,
	searchValue,
}: TDefaultDTO): Promise<IBrandingSetupsDTO> => {
	return client.get(`/${organizationsBrandingList}`, {
		params: {
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			searchValue,
		},
	});
};

export const createBrandingSetup = (data: ICreateBrandingSetupsDTO): Promise<IBrandingSetup> => {
	return client.post(organizationsBrandingCreate, data);
};

export const editBrandingSetup = ({ setupId, dto }: IEditBrandingSetupsDTO): Promise<IBrandingSetup> => {
	return client.put(`${organizationsBranding}/${setupId}/update`, {
		...dto,
	});
};

export const deleteBrandingSetup = (setupId: string): Promise<void> => {
	return client.delete(`${organizationsBranding}/${setupId}/delete`);
};

export const deleteBrandingSetups = (ids: string[]): Promise<void> => {
	return client.delete(`${organizationsBranding}/delete`, {
		params: {
			ids,
		},
		paramsSerializer: params => qs.stringify(params, { indices: false }),
	});
};
